import React, { useState } from 'react';

const Navbar = ({ onOpenModal }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    { href: '#how-it-works', label: 'How it works' },
    { href: '#examples', label: 'Use Cases' },
    { href: '#pricing', label: 'Prices' },
    { href: '#datasets', label: 'Datasets' }
  ];

  console.log('Navbar component is rendering');

  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          {/* Left Column - Logo and Navigation */}
          <div className="navbar-left">
            {/* Logo */}
            <div className="logo">
              <div className="logo-icon">S</div>
              <div className="logo-text">Simulated Experience Studio</div>
            </div>

            {/* Desktop Navigation Links */}
            <div className="nav-links">
              {navItems.map((item, index) => (
                <a 
                  key={index}
                  href={item.href} 
                  className="nav-link"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          {/* Right Column - CTA Button */}
          <div className="navbar-right">
            {/* CTA Button */}
            <div className="cta-button">
              <button 
                onClick={() => onOpenModal && onOpenModal()}
                className="btn btn-primary"
              >
                Materialize It!
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="mobile-menu-btn"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle mobile menu"
            >
              <svg className="menu-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="mobile-menu">
            <div className="mobile-menu-content">
              {navItems.map((item, index) => (
                <a 
                  key={index}
                  href={item.href} 
                  className="mobile-nav-link"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <button 
                className="btn btn-primary mobile-cta"
                onClick={() => {
                  setIsMobileMenuOpen(false);
                  if (onOpenModal) onOpenModal();
                }}
              >
                Materialize It!
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
